<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Servicio Técnico'"
      />
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />

            <div
              class="form_label"
              v-text="'Código Cliente'"
            />
            <div class="form__field">
              <label for="codeClient"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="codeClient"
                ref="codeClient"
                v-model="codeClient"
                disabled
                autocomplete="off"
                type="text"
                name="codeClient"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'numbers')"
                @change="cleanSpecialChars('codeClient', 'numbers')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Dirección Local'"
            />
            <div class="form__field">
              <label for="localAdress"><v-icon
                name="map-marker-alt"
                scale="1"
              /></label>
              <input
                id="localAdress"
                ref="localAdress"
                v-model="localAdress"
                disabled
                autocomplete="off"
                type="text"
                name="localAdress"
                value=""
                placeholder=""
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'localAdress')"
                @change="cleanSpecialChars('localAdress', 'localAdress')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Teléfono *'"
            />
            <div class="form__field">
              <label
                for="phone"
              ><v-icon
                name="mobile-alt"
                scale="1"
              /></label>
              <input
                id="phone"
                ref="phone"
                v-model="phone"
                autocomplete="off"
                type="text"
                name="phone"
                value=""
                maxlength="9"
                placeholder="123456789"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('fantasyNameLocal')"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('phone', 'phone')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Nombre de fantasía local *'"
            />
            <div class="form__field">
              <label
                for="fantasyNameLocal"
              ><v-icon
                name="store"
                scale="1"
              /></label>
              <input
                id="fantasyNameLocal"
                ref="fantasyNameLocal"
                v-model="fantasyNameLocal"
                autocomplete="off"
                type="text"
                name="fantasyNameLocal"
                value=""
                placeholder="La licorería"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('firstName')"
                @keypress="keyPressCheckSpecialChars($event, 'comment')"
                @change="cleanSpecialChars('fantasyNameLocal', 'comment')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Nombre *'"
            />
            <div class="form__field">
              <label for="firstName"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="firstName"
                ref="firstName"
                v-model="firstName"
                autocomplete="off"
                type="text"
                name="firstName"
                value=""
                placeholder="Nombre de contacto"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('lastName')"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('firstName', 'name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Apellido *'"
            />
            <div class="form__field">
              <label for="lastName"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="lastName"
                ref="lastName"
                v-model="lastName"
                autocomplete="off"
                type="text"
                name="lastName"
                value=""
                placeholder="Apellido de contacto"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @change="cleanSpecialChars('lastName', 'name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Detalle de Atención'"
            />
            <select
              id="form_estilos"
              v-model="detailAttention"
              :multiple="false"
              class="formulario_combo"
            >
              <option value>
                SELECCIONAR...
              </option>
              <option value="1">
                EQUIPO NO ENFRIA
              </option>
              <option value="2">
                RUIDO EXTRAÑO
              </option>
              <option value="3">
                PROBLEMA PUERTAS
              </option>
              <option value="4">
                EQUIPO NO ENCIENDE
              </option>
              <option value="5">
                LUZ INTERIOR NO ENCIENDE
              </option>
              <option value="6">
                OTROS
              </option>
            </select>

            <div
              class="form_label"
              v-text="'Publicidad equipo *'"
            />
            <div class="form__field">
              <label for="advertisingMachine"><v-icon
                name="ad"
                scale="1"
              /></label>
              <input
                id="advertisingMachine"
                ref="advertisingMachine"
                v-model="advertisingMachine"
                autocomplete="off"
                type="text"
                name="advertisingMachine"
                value=""
                :disabled="advertisingMachineDisabled == 1"
                placeholder="Cristal"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('numberSerie')"
                @keypress="keyPressCheckSpecialChars($event, 'advertisingMachine')"
                @change="cleanSpecialChars('advertisingMachine', 'advertisingMachine')"
              >
            </div>
            <div
              class="form_label"
              v-text="'N° Serie Equipo *'"
            />
            <div class="form__field">
              <label
                v-tooltip="{content: `<center><strong>¿Donde se encuentra el N° de serie?</strong></center></br><img src='https://mistral-staging-bucket.storage.googleapis.com/assets/serieccu-b6961922c97d532d663b738fc4c36d6d8300a96653503fb344dabcea894c12d1.png' width='100%' height='100%' /> </br> <p style='text-align: justify;'> El número de serie se encuentra al interior del equipo en el lado superior izquierdo, donde además se encuentra información de MODELO, INFORMACIÓN TÉCNICA y, otros</p>`, html: true, show: false}"
                for="numberSerie"
              ><v-icon
                name="question"
                scale="1"
              /></label>
              <input

                id="numberSerie"
                ref="numberSerie"
                v-model="numberSerie"
                autocomplete="off"
                type="text"
                name="numberSerie"
                value=""
                :disabled="numberSerieDisabled == 1"
                placeholder="123456789"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('numberDoors')"
                @keypress="keyPressCheckSpecialChars($event, 'orderNumber')"
                @change="cleanSpecialChars('numberSerie', 'orderNumber')"
              >
            </div>
            <div
              class="form_label"
              v-text="'N° Puertas / Salidas *'"
            />
            <div class="form__field">
              <label for="numberDoors"><v-icon
                name="door-closed"
                scale="1"
              /></label>
              <input
                id="numberDoors"
                ref="numberDoors"
                v-model="numberDoors"
                autocomplete="off"
                type="number"
                :disabled="numberDoorsDisabled == 1"
                name="numberDoors"
                value=""
                placeholder="2"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('scheduleVisit')"
                @keypress="keyPressCheckSpecialChars($event, 'numbers')"
                @change="cleanSpecialChars('numberDoors', 'numbers')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Horario de Visita *'"
            />
            <div class="form__field">
              <label for="scheduleVisit"><v-icon
                name="clock"
                scale="1"
              /></label>
              <input
                id="scheduleVisit"
                ref="scheduleVisit"
                v-model="scheduleVisit"
                autocomplete="off"
                type="text"
                name="scheduleVisit"
                value=""
                placeholder="15:00"
                required
                @focus="_clearError"
                @keyup.enter="focusTo('scheduleVisit')"
                @keypress="keyPressCheckSpecialChars($event, 'scheduleVisit')"
                @change="cleanSpecialChars('scheduleVisit', 'scheduleVisit')"
              >
            </div>

            <!-- TEXTAREA -->

            <div
              class="score-subtitle"
              style="margin-bottom: 5px;"
            >
              Comentario
            </div>
            <div class="score-comments">
              <textarea
                v-model="comment"
                @keypress="keyPressCheckSpecialChars($event, 'comment')"
                @change="cleanSpecialChars('comment', 'comment')"
              />
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/store'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/door-closed'
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/ad'
import 'vue-awesome/icons/mobile-alt'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {},
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      nombreOrigen: '',
      emailOrigen: '',
      telefonoOrigen: '',
      codeClient: '',
      localAdress: '',
      phone: '',
      fantasyNameLocal: '',
      firstName: '',
      lastName: '',
      detailAttention: '',
      advertisingMachine: '',
      numberSerie: '',
      numberDoors: '',
      scheduleVisit: '',
      comment: '',
      numberSerieDisabled: 0,
      numberDoorsDisabled: 0,
      advertisingMachineDisabled: 0
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'CCUServicioTecnicoForm') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log("e.dato:",e.dato);
        // this.title = e.dato.title ? e.dato.title : "Contactar Ejecutivo";
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone ? e.dato.fields.phone : ''
        this.clientAddressOrigen = e.dato.fields.address ? e.dato.fields.address : ''
        this.clientCodeOrigen = e.dato.fields.client_code ? e.dato.fields.client_code : ''
        this.clientPhoneOrigen = e.dato.fields.client_phone ? e.dato.fields.client_phone : ''
        this.tokenOrigen = e.dato.fields.token ? e.dato.fields.token : ''
        this.machineCategoryOrigen = e.dato.fields.machine_category ? e.dato.fields.machine_category : ''
        this.machineInstallDateOrigen = e.dato.fields.machine_install_date ? e.dato.fields.machine_install_date : ''
        this.machineMarkOrigen = e.dato.fields.machine_mark ? e.dato.fields.machine_mark : ''
        this.machineAssociatedBrandOrigen = e.dato.fields.machine_associated_brand ? e.dato.fields.machine_associated_brand : ''
        this.machineModelOrigen = e.dato.fields.machine_model ? e.dato.fields.machine_model : ''
        this.machineNumberDoorsOrigen = e.dato.fields.machine_number_doors ? e.dato.fields.machine_number_doors : ''
        this.machineNumberSerieOrigen = e.dato.fields.machine_number_serie ? e.dato.fields.machine_number_serie : ''
        this.firstName = this.nombreOrigen
        this.email = this.emailOrigen
        this.phone = this.telefonoOrigen
        this.codeClient = this.clientCodeOrigen
        this.localAdress = this.clientAddressOrigen
        this.phone = this.clientPhoneOrigen
        this.numberSerie = this.machineNumberSerieOrigen
        this.numberDoors = this.machineNumberDoorsOrigen
        this.advertisingMachine = this.machineAssociatedBrandOrigen

        if (this.machineNumberSerieOrigen && this.machineNumberSerieOrigen !== '') {
          this.numberSerieDisabled = 1
        }
        if (this.machineNumberDoorsOrigen && this.machineNumberDoorsOrigen !== '') {
          this.numberDoorsDisabled = 1
        }
        if (this.machineAssociatedBrandOrigen && this.machineAssociatedBrandOrigen !== '') {
          this.advertisingMachineDisabled = 1
        }
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      this.$refs[el].focus()
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      return (this[val] = utils.cleanSpecialChars(this[val], type))
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.codeClient) {
        this.$refs.codeClient.focus()
        this.errormsg = 'Debes ingresar Código Cliente'
        return
      }
      if (!this.localAdress) {
        this.$refs.localAdress.focus()
        this.errormsg = 'Debes ingresar Direccion Local'
        return
      }
      if (!this.phone) {
        this.$refs.phone.focus()
        this.errormsg = 'Debes ingresar teléfono'
        return
      }
      if (!this.fantasyNameLocal) {
        this.$refs.fantasyNameLocal.focus()
        this.errormsg = 'Debes ingresar Nombre de fantasía local'
        return
      }
      if (!this.firstName) {
        this.$refs.firstName.focus()
        this.errormsg = 'Debes ingresar Nombre'
        return
      }
      if (!this.lastName) {
        this.$refs.lastName.focus()
        this.errormsg = 'Debes ingresar Apellido'
        return
      }
      if (!this.detailAttention) {
        this.errormsg = 'Debes seleccionar Detalle de Atención'
        return
      }

      if (!this.advertisingMachine) {
        this.$refs.advertisingMachine.focus()
        this.errormsg = 'Debes ingresar Publicidad equipo'
        return
      }
      if (!this.numberSerie) {
        this.$refs.numberSerie.focus()
        this.errormsg = 'Debes ingresar N° Serie Equipo'
        return
      }
      if (!this.numberDoors) {
        this.$refs.numberDoors.focus()
        this.errormsg = 'Debes ingresar N° Puertas / Salidas'
        return
      }
      if (!this.scheduleVisit) {
        this.$refs.scheduleVisit.focus()
        this.errormsg = 'Debes ingresar Horario de Visita'
        return
      }
      if (!this.comment) {
        this.$refs.comment.focus()
        this.errormsg = 'Debes ingresar Comentario'
        return
      }
      serverUI.$emit('FormEvent', {
        form: 'CCUServicioTecnicoForm',
        evento: 'sentClick',
        data: {
          fields: {
            codeClient: this.codeClient,
            localAdress: this.localAdress,
            phone: this.phone,
            fantasyNameLocal: this.fantasyNameLocal,
            firstName: this.firstName,
            lastName: this.lastName,
            detailAttention: this.detailAttention,
            advertisingMachine: this.advertisingMachine,
            numberSerie: this.numberSerie,
            numberDoors: this.numberDoors,
            scheduleVisit: this.scheduleVisit,
            comment: this.comment,
            token: this.tokenOrigen
          }
        }
      })
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'CCUServicioTecnicoForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
  margin-bottom: 7px;
}

.form-box-body {
    height: 340px;
}
</style>
